const breadCrumb = "Rendimento - Parametrização";

const routes = [
  {
    path: "/cadastro-de-parametros-de-afericao",
    name: "cadastro_de_parametros_de_afericao",
    meta: {
      allowedPermissions: [
        "parametro_rendimento_delete",
        "parametro_rendimento_insert",
        "parametro_rendimento_list",
        "parametro_rendimento_update",
      ],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CadastroDeParametrosDeAfericao/CadastroDeParametrosDeAfericaoHome.vue"
      ),
  },
  {
    path: "/cadastro-de-parametros-de-afericao/novo",
    name: "cadastro_de_parametros_de_afericao_cad",
    meta: {
      allowedPermissions: [
        "parametro_rendimento_insert",
        "parametro_rendimento_list",
      ],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CadastroDeParametrosDeAfericao/CadastroDeParametrosDeAfericaoCad.vue"
      ),
  },
  {
    path: "/cadastro-de-parametros-de-afericao/edit/:id",
    name: "cadastro_de_parametros_de_afericao_edit",
    meta: {
      allowedPermissions: [
        "parametro_rendimento_list",
        "parametro_rendimento_update",
      ],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CadastroDeParametrosDeAfericao/CadastroDeParametrosDeAfericaoEdit.vue"
      ),
  },
  {
    path: "/cadastro-de-parametros-de-afericao/visualizar/:id",
    name: "cadastro_de_parametros_de_afericao_visualizar",
    meta: {
      allowedPermissions: ["parametro_rendimento_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CadastroDeParametrosDeAfericao/CadastroDeParametrosDeAfericaoVisualizar.vue"
      ),
  },
  {
    path: "/replica-parametros-de-afericao",
    name: "replica-parametros-de-afericao",
    meta: {
      allowedPermissions: ["indicador_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ReplicaParametrosDeAfericao/ReplicaParametrosDeAfericao.vue"
      ),
  },
];

export default routes;
